import React from "react";

const JSONFormatter = ({ data }) => {
  const renderValue = (value) => {
    if (value === null) return "";
    if (Array.isArray(value)) {
      return (
        <div style={{ paddingLeft: 16 }}>
          {value.map((item, index) => (
            <div key={index}> {renderValue(item)}</div>
          ))}
        </div>
      );
    } else if (typeof value === "object") {
      return (
        <div style={{ paddingLeft: 16 }}>
          {Object.entries(value).map(([key, val]) => (
            <div key={key}>
              <strong>{key}</strong>: {renderValue(val)}
            </div>
          ))}
        </div>
      );
    } else {
      return <span>{value.toString()}</span>;
    }
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", lineHeight: 1.6 }}>
      {renderValue(data)}
    </div>
  );
};

export default JSONFormatter;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/change-watchlist-entry-match-status-modal/JSONFormatter.jsx